<template>
  <f7-page name="bandeja-asignacion-cobros" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Asignar gestor de cobro</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="cargar" icon-f7="arrow_2_circlepath" style="color:#c8d3e5"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · se lee en directo de la consulta de Facturas, sin caché, y aquí con más motivo: es la
         pantalla desde la que se escribe, y marcar facturas sobre una foto vieja es ofrecer repartir
         lo que ya tiene dueño. -->
    <div class="sello-datos-bar" v-if="hayDatos"><sello-datos estado="vivo" /></div>
    <f7-page-content style="padding-top:0">

      <!-- #749 · el preloader a pantalla entera es SOLO de la primera carga, la única que no tiene
           nada que enseñar todavía. Una recarga con la bandeja delante no pasa por aquí: avisa junto
           al conmutador y en la cabecera de la tabla, y deja la pantalla donde está (ver `cargar`). -->
      <f7-block v-if="cargando" class="text-align-center"><f7-preloader></f7-preloader></f7-block>

      <f7-block v-if="error" class="aviso-error">{{ error }}</f7-block>

      <!-- EL ESTADO DE LA ÚLTIMA ESCRITURA · FUERA del `v-if` del `dto`, y eso es lo que importa.
           `asignar()` recarga siempre después de escribir, y si esa recarga falla `cargar()` deja el
           `dto` en null: ahí dentro, el aviso de «no se sabe si se ha guardado» se quedaba oculto
           justo en el caso para el que se escribió —una caída de red tumba las dos peticiones—, y la
           persona solo veía el error genérico de carga y podía reintentar sin saber que la primera
           escritura quizá entró. Hallazgo P1 de la revisión CODEX del PR #1751.

           Y tampoco dependen de `cargando`: si se ocultaran mientras recarga, el resultado de la
           asignación parpadearía fuera de pantalla precisamente cuando se está leyendo. -->
      <div class="bloque bloque-error-asignacion" v-if="errorAsignacion">
        <p class="bloque-titulo">
          Última asignación
          <button type="button" class="boton-cerrar-resultado" @click="errorAsignacion = null">
            Ocultar
          </button>
        </p>
        <p class="resultado-resumen resultado-resumen-nada">{{ errorAsignacion }}</p>
      </div>

      <!-- EL RESULTADO DE LA ÚLTIMA ASIGNACIÓN · se queda en pantalla, porque es lo que hay que
           leer. No es un «hecho»: puede traer facturas que no se han podido asignar. -->
      <div class="bloque bloque-resultado" v-if="resultado">
        <p class="bloque-titulo">
          Última asignación
          <button type="button" class="boton-cerrar-resultado" @click="resultado = null">Ocultar</button>
        </p>
        <p class="resultado-resumen" :class="{'resultado-resumen-nada': !resultado.asignadas}">
          {{ resultado.resumen }}
        </p>
        <p class="resultado-gestor" v-if="resultado.gestor && !resultado.rechazo">
          Gestor: {{ resultado.nombreGestor || resultado.gestor }} ({{ resultado.gestor }})
        </p>
        <div class="resultado-omitidas" v-if="omitidas.length">
          <div v-for="omitida in omitidas" :key="omitida.id" class="resultado-omitida">
            <span class="resultado-omitida-codigo">{{ texto(omitida.codigo) }}</span>
            <span class="resultado-omitida-motivo"
              :class="{'resultado-omitida-aviso': avisa(omitida)}">
              {{ omitida.explicacion }}
            </span>
          </div>
        </div>
      </div>

      <!-- #749 · la bandeja depende solo de que haya datos, ya no de la carga. Es el mismo fallo que se corrigió
           en el Centro de Cobros: cambiar de modo, filtrar por gestor, recargar o asignar ponía
           `cargando` a true, Vue desmontaba la bandeja entera y al llegar la respuesta la montaba
           otra vez con el scroll arriba. La pantalla en blanco era un `v-if` que la propia recarga
           apagaba. -->
      <template v-if="dto">

        <!-- D-COB-5 · qué parte de la cartera se está viendo. Lo dice el servidor, que es quien
             aplica el recorte. Mismo criterio y mismo texto que la pantalla de la cartera. -->
        <div class="linea-alcance">
          <f7-icon f7="person_crop_circle" class="linea-alcance-icono"></f7-icon>
          <span>{{ dto.alcance }}</span>
        </div>

        <!-- CRITERIO 6 · el gestor de cobro ve la bandeja y no se asigna facturas. Se dice con
             palabras: un botón que no está, sin explicación, se lee como que la pantalla está a
             medias. -->
        <div class="nota-dato nota-dato-lectura" v-if="!dto.puedeAsignar">
          <f7-icon f7="eye" class="nota-dato-icono"></f7-icon>
          <span>{{ dto.motivoSoloLectura }}</span>
        </div>

        <!-- D-COB-6 · por qué este número no es el de documentos abiertos del Centro de Cobros. -->
        <div class="nota-dato">
          <f7-icon f7="info_circle" class="nota-dato-icono"></f7-icon>
          <span>
            {{ dto.notaAbonos }}
            <template v-if="dto.abonosExcluidos">
              Hoy quedan fuera {{ dto.abonosExcluidos }} abonos abiertos.
            </template>
          </span>
        </div>

        <!-- D-COB-8 · lo que no se puede clasificar se dice, no se cuela ni desaparece. -->
        <div class="nota-dato nota-dato-alerta" v-if="dto.sinTipoExcluidos">
          <f7-icon f7="exclamationmark_triangle" class="nota-dato-icono-alerta"></f7-icon>
          <span>
            Hay {{ dto.sinTipoExcluidos }} documentos abiertos que no dicen si son factura o abono y
            se quedan fuera de la bandeja: no se les puede asignar gestor de cobro sin saber qué son.
          </span>
        </div>

        <!-- LOS DOS RECUENTOS · siempre los dos, en cualquiera de los dos modos. Es lo que hace que
             se vea el efecto de una asignación: lo que asignas sale de uno y entra en el otro, y la
             suma de los dos no se mueve. -->
        <!-- El resaltado sigue a lo que enseña la tabla (`modoDeLasFilas`) y no al botón pulsado: es
             lo que dice cuál de las dos cifras se está mirando abajo, y mientras se recarga la tabla
             todavía es la del modo anterior. -->
        <div class="titulares">
          <div class="titular" :class="{'titular-activo': modoDeLasFilas === 'SIN_GESTOR'}">
            <p class="titular-rotulo">Sin gestor de cobro</p>
            <p class="titular-cifra">{{ numero(dto.facturasSinGestor) }}</p>
            <p class="titular-nota">
              facturas · {{ formatEuros(dto.importeSinGestor) }} € de saldo pendiente
            </p>
          </div>
          <div class="titular" :class="{'titular-activo': modoDeLasFilas === 'ASIGNADAS'}">
            <p class="titular-rotulo">Ya asignadas</p>
            <p class="titular-cifra">{{ numero(dto.facturasAsignadas) }}</p>
            <p class="titular-nota">
              facturas · {{ formatEuros(dto.importeAsignado) }} € de saldo pendiente
            </p>
          </div>
        </div>

        <!-- EL CONMUTADOR -->
        <div class="bloque">
          <div class="modos">
            <button type="button" class="modo-btn" :class="{'modo-btn-activo': modo === 'SIN_GESTOR'}"
              :aria-pressed="modo === 'SIN_GESTOR' ? 'true' : 'false'"
              @click="cambiarModo('SIN_GESTOR')">Sin gestor</button>
            <button type="button" class="modo-btn" :class="{'modo-btn-activo': modo === 'ASIGNADAS'}"
              :aria-pressed="modo === 'ASIGNADAS' ? 'true' : 'false'"
              @click="cambiarModo('ASIGNADAS')">Ya asignadas</button>
          </div>
          <!-- #749 · el aviso de carga va también aquí, junto al control que se acaba de pulsar: la
               cabecera de la tabla puede quedar fuera de la vista, y el rótulo de debajo es todavía
               el de la lista anterior. -->
          <p class="modo-rotulo">
            {{ dto.rotuloModo }}
            <span class="aviso-refrescando" v-if="refrescando">Actualizando…</span>
          </p>

          <!-- El filtro por gestor es del modo «ya asignadas»: es con lo que se reparte la cartera
               de quien no está. En el otro modo no hay gestor por el que filtrar. -->
          <label class="filtro" v-if="modo === 'ASIGNADAS'">
            <span class="filtro-rotulo">Gestor actual</span>
            <select v-model="gestorFiltrado" @change="aplicarFiltro">
              <option :value="null">Todos</option>
              <option v-for="opcion in opcionesFiltroGestor" :key="opcion.clave"
                :value="opcion.clave">
                {{ opcion.etiqueta }} ({{ opcion.documentos }})
              </option>
            </select>
            <span class="filtro-ayuda" v-if="!gestoresConCartera.length">
              Todavía no hay ninguna factura con gestor asignado
            </span>
          </label>
        </div>

        <!-- LA BARRA DE ASIGNACIÓN · solo para quien puede asignar (criterio 5). -->
        <div class="bloque bloque-asignar" v-if="dto.puedeAsignar">
          <p class="bloque-titulo">Asignar en bloque</p>
          <div class="asignar-fila">
            <span class="asignar-marcadas">
              {{ marcadas.length }} {{ marcadas.length === 1 ? 'factura marcada' : 'facturas marcadas' }}
            </span>
            <!-- EL DESPLEGABLE DE GESTOR, QUE AHORA ES UN BUSCADOR (#479) · son TODOS los empleados
                 activos, así que para llegar a una persona había que bajar la lista entera. Se
                 escribe parte del nombre o del código y la lista se recorta mientras se escribe,
                 sin distinguir mayúsculas ni acentos. El filtrado es aquí y no en la API:
                 `gestoresDisponibles` ya llega completo en la respuesta de la bandeja.

                 Un combo propio y no `rAutocomplete`, que es el autocompletado del proyecto: ese
                 componente vive sobre `r-form` —lee y escribe en `form.formData`, pinta
                 `form.errors[name]` y llama a `form.$emit`—, y aquí no hay formulario: lo elegido
                 es `gestorElegido`, estado de esta pantalla. Y tampoco un `<input list>` con
                 `<datalist>`: ahí filtra el navegador y su comparación SÍ distingue acentos, que es
                 justo lo que se pide que no pase.

                 LA INVARIANTE QUE LO SOSTIENE, y de la que cuelgan los avisos de abajo: el cuadro
                 enseña un nombre **si y solo si** `gestorElegido` es ese nombre y sigue estando en
                 la lista de esta carga. Por eso el texto se deriva de `gestoresDisponibles`
                 (`etiquetaGestorElegido`) en vez de guardarse aparte, y por eso escribir deja de
                 haber gestor elegido: si no, el cuadro podría decir «pepe» y la asignación irse a
                 quien se eligió antes. -->
            <div class="asignar-buscador">
              <input type="text" class="asignar-select" autocomplete="off" role="combobox"
                ref="campoGestor"
                aria-autocomplete="list" aria-controls="lista-gestores-asignar"
                :aria-expanded="listaGestoresAbierta ? 'true' : 'false'"
                :aria-activedescendant="idOpcionResaltada"
                placeholder="Elige un gestor…"
                :disabled="!hayGestores"
                :value="textoBuscadorGestor"
                @focus="abrirListaGestores"
                @click="abrirListaGestores"
                @input="buscarGestor($event.target.value)"
                @blur="cerrarListaGestores"
                @keydown.down.prevent="moverResaltado(1)"
                @keydown.up.prevent="moverResaltado(-1)"
                @keydown.enter.prevent="elegirResaltado"
                @keydown.esc="cancelarBusquedaGestor" />
              <!-- La flecha dice que esto se despliega, y no recoge pulsaciones a propósito: el
                   clic lo tiene que recibir el campo, que es quien abre la lista (criterio 2: se
                   puede abrir y elegir sin escribir nada). -->
              <span class="asignar-buscador-flecha" aria-hidden="true"></span>
              <ul class="asignar-buscador-lista" id="lista-gestores-asignar" role="listbox"
                ref="listaGestores" v-if="listaGestoresAbierta">
                <!-- `mousedown` Y `click`, los dos, porque son dos vías de activación distintas y
                     cada una se queda corta sin la otra:

                     - con el ratón tiene que ser `mousedown`, porque el `click` llega después del
                       `blur` del campo, que ya habría cerrado la lista, y no se elegiría a nadie;
                     - un lector de pantalla —o cualquier tecnología de asistencia— activa la opción
                       sintetizando un `click` **sin** la secuencia física de `mousedown`/`mouseup`,
                       así que sin este segundo manejador la opción tocada no se puede elegir de
                       ninguna manera. El `<select>` de antes sí admitía esa vía, y perderla es
                       dejar el control sin forma de usarse para quien lo maneja así.

                     Que el ratón dispare los dos no estorba: `elegirGestor` vuelve a dejar lo mismo
                     —el username elegido, la lista cerrada y la etiqueta seleccionada—, así que una
                     segunda llamada no cambia nada. Y en la práctica no llega a pasar: al cerrarse
                     la lista, el `<li>` ya no está en el DOM cuando habría tocado el `click`. -->
                <li v-for="(gestor, i) in gestoresFiltrados" :key="gestor.username"
                  :id="'gestor-opcion-' + i" ref="opcionesGestor" role="option"
                  class="asignar-buscador-opcion"
                  :class="{'asignar-buscador-opcion-resaltada': i === indiceResaltado}"
                  :aria-selected="esElGestorElegido(gestor) ? 'true' : 'false'"
                  @mouseenter="indiceResaltado = i"
                  @click="elegirGestor(gestor)"
                  @mousedown.prevent="elegirGestor(gestor)">{{ etiquetaGestor(gestor) }}</li>
                <li class="asignar-buscador-vacio" v-if="!gestoresFiltrados.length">
                  Ningún empleado activo casa con lo escrito.
                </li>
              </ul>
            </div>
            <button type="button" class="boton-asignar" :disabled="!sePuedeAsignar" @click="asignar">
              {{ asignando ? 'Asignando…' : 'Asignar' }}
            </button>
          </div>
          <p class="filtro-ayuda" v-if="dto.faltanGestoresDisponibles">
            {{ dto.faltanGestoresDisponibles }}
          </p>
          <p class="filtro-ayuda" v-if="hayGestores && !marcadas.length">
            Marca las facturas que quieras asignar en la tabla de abajo.
          </p>
          <!-- Con facturas marcadas y sin gestor válido, el botón está apagado y hay que decir por
               qué: el caso no es solo «no has elegido», también es «al recargar, quien habías
               elegido ya no está entre los empleados activos» y el desplegable ha vuelto solo, y
               desde la #479 también «has escrito en el buscador y todavía no has elegido de la
               lista». Los tres dicen lo mismo —no hay gestor— y por eso les vale este aviso. -->
          <p class="filtro-ayuda" v-if="hayGestores && marcadas.length && !gestorElegidoVigente">
            Elige un gestor en el desplegable para poder asignar.
          </p>
          <p class="filtro-ayuda" v-if="marcadas.length >= dto.topeAsignacion">
            Has llegado al tope de {{ dto.topeAsignacion }} facturas por asignación. Asigna estas y
            sigue con las siguientes.
          </p>
        </div>

        <!-- LA TABLA · #749 · mientras se recarga sigue a la vista, atenuada y sin poder marcarse:
             son las filas de la lista anterior, y una marca puesta ahora iría sobre una factura que
             la lista nueva puede no traer (ver `marcar`). -->
        <div class="bloque" :class="{'bloque-refrescando': refrescando}">
          <p class="bloque-titulo">
            {{ numero(dto.documentos) }}
            {{ dto.documentos === 1 ? 'factura' : 'facturas' }}
            · {{ formatEuros(dto.importeTotal) }} €
            <span class="aviso-refrescando" v-if="refrescando">Actualizando…</span>
          </p>
          <p class="bloque-nota" v-if="dto.filasOmitidas">
            Se enseñan las {{ filas.length }} de mayor saldo pendiente, y
            {{ dto.filasOmitidas }} no caben en la tabla. <strong>Esas no se pueden marcar</strong>:
            asigna estas, recarga y sigue.
          </p>
          <p class="bloque-vacio" v-if="!filas.length">{{ textoTablaVacia }}</p>

          <div class="marcar-todas" v-if="dto.puedeAsignar && filas.length">
            <button type="button" class="boton-marcar" @click="marcarTodas" :disabled="refrescando">
              Marcar las visibles
            </button>
            <button type="button" class="boton-marcar" @click="quitarMarcas"
              :disabled="refrescando || !marcadas.length">
              Quitar marcas
            </button>
          </div>

          <div class="tabla-scroll" v-if="filas.length">
            <table class="tabla">
              <thead>
                <tr>
                  <th v-if="dto.puedeAsignar"></th>
                  <th>Cliente</th>
                  <th>Factura</th>
                  <th>Emisión</th>
                  <th class="num">Días</th>
                  <th>Vencimiento</th>
                  <th class="num">Retraso</th>
                  <th class="num">Saldo pendiente</th>
                  <!-- «en la factura» y no «Estado de gestión» a secas: lo que esta columna enseña
                       es el campo guardado en el documento, que NO es el «gestionada» de D-COB-4.
                       El pie lo explica. -->
                  <th>Estado de gestión <span class="th-matiz">(en la factura)</span></th>
                  <th>Empleado de ventas</th>
                  <th v-if="modoDeLasFilas === 'ASIGNADAS'">Gestor actual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="fila in filas" :key="fila.id" :class="{'fila-marcada': !!seleccion[fila.id]}">
                  <td v-if="dto.puedeAsignar">
                    <input type="checkbox" :checked="!!seleccion[fila.id]"
                      :disabled="refrescando
                        || (!seleccion[fila.id] && marcadas.length >= dto.topeAsignacion)"
                      @change="marcar(fila, $event.target.checked)" />
                  </td>
                  <td>{{ texto(fila.cliente) }}</td>
                  <!-- EL NÚMERO ABRE LA FICHA, EN PESTAÑA NUEVA. Aquí se decide a quién se le
                       asigna una factura de 13.000 € con 400 días de retraso, y hasta ahora para
                       verla había que salir de la pantalla, ir a Facturas y buscarla a mano.
                       Pestaña nueva y no navegación: lo marcado en la tabla es estado de esta
                       pantalla y se pierde al salir (ver el comentario de `seleccion`). -->
                  <td>
                    <button type="button" class="enlace-factura" v-if="fila.id"
                      :title="'Abrir la ficha de ' + texto(fila.codigo) + ' en una pestaña nueva'"
                      @click="abrirFicha(fila)">{{ texto(fila.codigo) }}</button>
                    <span v-else>{{ texto(fila.codigo) }}</span>
                  </td>
                  <td>{{ formatFecha(fila.fechaEmision) }}</td>
                  <td class="num">{{ numero(fila.diasAntiguedad) }}</td>
                  <td>{{ formatFecha(fila.fechaVencimiento) }}</td>
                  <td class="num" :class="{'num-alerta': fila.diasRetraso}">{{ numero(fila.diasRetraso) }}</td>
                  <td class="num">{{ formatEuros(fila.saldoPendiente) }}</td>
                  <td :class="{'celda-falta': !fila.estadoGestion}">
                    {{ etiquetaEstadoGestion(fila.estadoGestion) }}
                  </td>
                  <td :class="{'celda-falta': !fila.empleadoVentas}">{{ texto(fila.empleadoVentas) }}</td>
                  <td v-if="modoDeLasFilas === 'ASIGNADAS'">{{ texto(fila.gestorCobro) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="nota-dato nota-dato-pie">{{ dto.notaOrden }}</p>
          <p class="nota-dato nota-dato-pie">{{ dto.notaSaldoPendiente }}</p>
          <!-- POR QUÉ HAY FILAS CON GUION EN «ESTADO DE GESTIÓN», que es la pregunta que hizo
               dirección al probar la pantalla.
               La columna es el campo `estadoGestionCobro` guardado en la factura, y el guion es que
               ESE CAMPO ESTÁ VACÍO. No se rellena con «Sin gestionar» por D-COB-8: un hueco no se
               disimula con un valor por defecto, y además son dos cosas distintas —una factura
               puede tener el campo en «Sin gestionar» y estar reclamada, y al revés—.
               Y D-COB-4 no cierra el guion, porque D-COB-4 define «gestionada» por las tareas
               T0045 posteriores al vencimiento, que esta pantalla NO cruza a propósito (está
               escrito en `FactCobroBandejaFacturaDTO`: aquí no se mira si está reclamada, sino
               quién tiene que reclamarla). El estado de D-COB-4 se ve en el Centro de Cobros. -->
          <p class="nota-dato nota-dato-pie">
            «Estado de gestión» es el campo que tiene guardado la factura, y un guion significa que
            ese campo está vacío: no se rellena solo (D-COB-8). <strong>No es el «gestionada» de
            D-COB-4</strong>, que se mide con las tareas de gestión de cobro posteriores al
            vencimiento y se consulta en el Centro de Cobros · La cartera. Esta pantalla no cruza
            las tareas: aquí se decide quién reclama, no si ya se ha reclamado.
          </p>
        </div>
      </template>
    </f7-page-content>
  </f7-page>
</template>

<style scoped>
.sello-datos-bar { padding: 6px 16px 0; }

.linea-alcance, .nota-dato {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 8px 16px 0;
  font-size: 12px;
  color: #4a5a78;
  line-height: 1.4;
}
.linea-alcance-icono, .nota-dato-icono { font-size: 16px; color: #185FA5; flex-shrink: 0; }
.nota-dato { background: #F2F7FD; border-radius: 8px; padding: 8px 10px; }
.nota-dato-pie { margin: 8px 0 0; }

/* Criterio 6 · el modo lectura no es un error: es cómo esta pantalla se le enseña al gestor. */
.nota-dato-lectura { background: #EEEDFE; color: #37307E; }

/* D-COB-8 · en ámbar y no en rojo: no es un fallo de la pantalla, es dato que falta. */
.nota-dato-alerta { background: #FDF4E3; color: #6B4A10; }
.nota-dato-icono-alerta { font-size: 16px; color: #9A6411; flex-shrink: 0; }

.aviso-error {
  background: #FDECEA;
  border-radius: 8px;
  color: #8E2B20;
  font-size: 13px;
}

/* LOS DOS RECUENTOS */
.titulares {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  padding: 12px 16px 0;
}
.titular {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px 14px;
}
/* El recuento del modo en el que estás, resaltado: son dos cifras parecidas y hay que saber cuál
   es la que estás mirando en la tabla. */
.titular-activo { border-color: #534AB7; background: #FAFAFE; }
.titular-rotulo { font-size: 11px; color: #7c8db0; margin: 0; text-transform: uppercase; }
.titular-cifra { font-size: 22px; font-weight: 700; color: #1a2744; margin: 4px 0 0; }
.titular-nota { font-size: 11px; color: #7c8db0; margin: 4px 0 0; line-height: 1.35; }

/* BLOQUES */
.bloque {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  margin: 12px 16px 0;
  padding: 12px 14px;
}
.bloque-titulo {
  font-size: 13px;
  font-weight: 600;
  color: #1a2744;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.bloque-nota { font-size: 11px; color: #9A6411; font-weight: 400; margin: 0 0 6px; line-height: 1.4; }
.bloque-vacio { font-size: 12px; color: #7c8db0; margin: 4px 0; }

/* #749 · el aviso de carga local, con el mismo aspecto que el de las cabeceras plegables del Centro
   de Cobros (`BloquePlegable`), para que las dos pantallas digan «se está actualizando» igual. */
.aviso-refrescando {
  margin-left: auto;
  font-size: 11px;
  font-weight: 400;
  color: #185FA5;
  animation: aviso-latido 1.1s ease-in-out infinite;
}
.modo-rotulo .aviso-refrescando { margin-left: 8px; }
@keyframes aviso-latido {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}
/* Las filas de antes se siguen leyendo, atenuadas: son las que había y eso tiene que notarse sin
   que desaparezcan. */
.bloque-refrescando .tabla-scroll { opacity: 0.6; }

/* EL CONMUTADOR */
.modos { display: flex; gap: 8px; }
.modo-btn {
  font-size: 12px;
  padding: 5px 12px;
  border: 1px solid #d7dde8;
  border-radius: 999px;
  background: white;
  color: #4a5a78;
}
.modo-btn-activo { background: #534AB7; border-color: #534AB7; color: white; }
.modo-rotulo { font-size: 11px; color: #7c8db0; margin: 8px 0 0; }

.filtro { display: flex; flex-direction: column; gap: 3px; margin-top: 10px; max-width: 320px; }
.filtro-rotulo { font-size: 11px; color: #7c8db0; }
.filtro select {
  font-size: 12px;
  padding: 5px 6px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  width: 100%;
}
.filtro-ayuda { font-size: 11px; color: #7c8db0; margin: 6px 0 0; line-height: 1.4; }

/* LA BARRA DE ASIGNACIÓN */
.bloque-asignar { border-color: #534AB7; }
.asignar-fila { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }
.asignar-marcadas { font-size: 12px; color: #1a2744; font-weight: 600; }
.asignar-select {
  font-size: 12px;
  padding: 5px 6px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  min-width: 200px;
}
/* EL BUSCADOR DE GESTOR (#479) · la caja es la misma que tenía el `<select>` —reutiliza
   `.asignar-select`— para que la barra se siga viendo igual; lo que cambia es que se escribe
   dentro y la lista la pinta la pantalla. */
.asignar-buscador { position: relative; min-width: 200px; }
.asignar-buscador .asignar-select {
  width: 100%;
  box-sizing: border-box;
  /* Sitio para la flecha, que va encima del campo. */
  padding-right: 20px;
}
/* Indicador de foco propio: el campo es la única parada de teclado de este control y Framework7
   le quita a sus entradas el recuadro del navegador. Sin condición de `:focus-visible`, porque en
   una entrada de texto el recuadro al pulsar con el ratón es lo esperable. */
.asignar-buscador .asignar-select:focus {
  outline: 2px solid #534AB7;
  outline-offset: 1px;
  border-color: #534AB7;
}
/* Criterio 5 · sin ningún gestor que ofrecer el control se ve apagado, y el motivo lo dice el
   servidor en la línea de debajo (`dto.faltanGestoresDisponibles`). */
.asignar-buscador .asignar-select:disabled { background: #f4f6fa; color: #9aa7bd; }
.asignar-buscador-flecha {
  position: absolute;
  top: 50%;
  right: 7px;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #7c8db0;
  /* Que el clic atraviese la flecha y llegue al campo. */
  pointer-events: none;
}
.asignar-buscador-lista {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  /* Por encima de la tabla de facturas, que es lo que hay justo debajo. */
  z-index: 30;
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  /* Sin hueco propio: lo que cierra la lista es que el campo pierda el foco, y un borde de lista
     sin opción debajo es un sitio donde se puede pulsar sin querer y perder lo escrito. Así casi
     todo el interior de la lista es una opción, que sí retiene el foco. */
  padding: 0;
  list-style: none;
  background: white;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(26, 39, 68, 0.14);
}
.asignar-buscador-opcion { font-size: 12px; padding: 7px 10px; color: #1a2744; cursor: pointer; }
.asignar-buscador-opcion-resaltada { background: #F3F2FD; }
.asignar-buscador-vacio { font-size: 11px; padding: 7px 10px; color: #7c8db0; }

.boton-asignar {
  font-size: 12px;
  padding: 6px 16px;
  border: 0;
  border-radius: 6px;
  background: #534AB7;
  color: white;
  font-weight: 600;
}
.boton-asignar:disabled { background: #c9c6e6; }

/* EL RESULTADO */
.bloque-resultado { border-color: #0F6E56; }
.bloque-error-asignacion { border-color: #B23B2C; background: #FFF7F6; }
.resultado-resumen { font-size: 13px; color: #0F6E56; font-weight: 600; margin: 0; }
.resultado-resumen-nada { color: #8E2B20; }
.resultado-gestor { font-size: 12px; color: #4a5a78; margin: 4px 0 0; }
.resultado-omitidas { margin-top: 8px; border-top: 1px solid #eef1f6; padding-top: 8px; }
.resultado-omitida { display: flex; flex-wrap: wrap; gap: 8px; padding: 3px 0; font-size: 11px; }
.resultado-omitida-codigo { color: #1a2744; font-weight: 600; min-width: 110px; }
.resultado-omitida-motivo { color: #4a5a78; }
.resultado-omitida-aviso { color: #8E2B20; font-weight: 600; }
.boton-cerrar-resultado {
  font-size: 11px;
  padding: 2px 8px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  color: #4a5a78;
  font-weight: 400;
  margin-left: auto;
}

/* LA TABLA */
.marcar-todas { display: flex; gap: 8px; margin-bottom: 8px; }
.boton-marcar {
  font-size: 11px;
  padding: 4px 10px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  color: #4a5a78;
}
.boton-marcar:disabled { color: #b8c2d4; }
.tabla-scroll { overflow-x: auto; }
.tabla { width: 100%; border-collapse: collapse; font-size: 11px; }
.tabla th {
  text-align: left;
  color: #7c8db0;
  font-weight: 600;
  padding: 6px 8px;
  border-bottom: 1px solid #d7dde8;
  white-space: nowrap;
}
.tabla td {
  padding: 6px 8px;
  border-bottom: 1px solid #eef1f6;
  color: #1a2744;
  white-space: nowrap;
}
.tabla .num { text-align: right; }
/* El matiz de la cabecera: en minúscula y más claro, para que no compita con el nombre de la
   columna pero se lea antes de interpretar el dato. */
.th-matiz { font-weight: 400; text-transform: none; color: #9aa7bd; }
/* El número de factura abre su ficha: un botón, no un enlace, para que el router de F7 no lo
   intercepte; con la pinta de enlace, que es lo que es. */
.enlace-factura {
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  color: #185FA5;
  text-decoration: underline;
  cursor: pointer;
}
.num-alerta { color: #B23B2C; font-weight: 600; }
.celda-falta { color: #9aa7bd; font-style: italic; }
.fila-marcada td { background: #F3F2FD; }
</style>

<script>
import SelloDatos from '../../components/SelloDatos.vue';
import FactCobro from '../../js/db/FactCobro.js';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

/**
 * La bandeja de asignación del gestor de cobro (COB-2, #188): **la única pantalla de todo el Centro
 * de Cobros que escribe**.
 *
 * Lista las facturas abiertas sin gestor —ordenadas por importe y antigüedad—, permite marcar varias
 * y asignarlas en bloque al gestor elegido en el desplegable; y con el conmutador «ya asignadas»,
 * filtradas por gestor, sirve para reasignar cuando hay que repartir la cartera de quien no está.
 *
 * TRES COSAS QUE DECIDE EL SERVIDOR Y ESTA PANTALLA NO:
 *
 *  1. **Si se puede asignar** (`puedeAsignar`). El criterio 5 es de Administración, Directores y
 *     Administrador, y el 6 dice que el gestor de cobro ve la bandeja en lectura. Deduciéndolo aquí
 *     de los roles que hubiera a mano, la pantalla podría enseñar el botón a quien el servidor va a
 *     rechazar, o esconderlo a quien sí puede.
 *  2. **Qué parte de la cartera se ve** (`alcance`), que es el recorte de D-COB-5 y lo aplica la
 *     propia consulta.
 *  3. **Qué ha pasado al asignar** (`resumen` y `omitidas`). Una respuesta correcta puede traer
 *     `asignadas: 0` —todas se habían cobrado entre medias, por ejemplo—, así que aquí no se da por
 *     hecho que ha ido bien: se enseña lo que dice el servidor.
 *
 * Y EL ESTADO QUE SÍ ES DE LA PANTALLA es uno: qué facturas están marcadas. Se tira entero en
 * cuanto cambia el conjunto —al cambiar de modo, al filtrar, al recargar y después de asignar—,
 * porque una marca que sobrevive a un cambio de lista apunta a una fila que ya no está delante y
 * asignaría una factura que la persona no está viendo.
 */
export default {
  components: { SelloDatos },
  data: function() {
    return {
      /**
       * La PRIMERA carga, la única que no tiene bandeja que enseñar todavía. Es la que pinta el
       * preloader de la pantalla entera.
       *
       * #749 · Antes valía para cualquier carga y apagaba la bandeja entera con cada cambio de modo
       * o de filtro. Una recarga con la bandeja delante pasa ahora por `refrescando`.
       */
      cargando: false,
      /** #749 · Que se está repitiendo la lectura **con la bandeja de antes en pantalla**. */
      refrescando: false,
      /**
       * #749 · Por qué gestor salió filtrada la tabla que hay en pantalla, o `null`. Se apunta al
       * llegar la respuesta y no se lee de `gestorFiltrado`: mientras la lectura nueva está en vuelo,
       * el selector ya dice lo que se acaba de pedir y la tabla todavía es la de antes.
       */
      gestorDeLasFilas: null,
      asignando: false,
      /** Por qué no se ha podido traer la bandeja. Lo limpia cada carga. */
      error: null,
      /**
       * Por qué no se sabe qué ha pasado con la última asignación.
       *
       * Aparte de `error` a propósito, y no por pulcritud: `asignar()` recarga la bandeja justo
       * después de fallar —hay que recargar, porque lo que ha quedado escrito lo sabe la base de
       * datos y no esta pantalla— y `cargar()` limpia `error`. Con el aviso de la escritura ahí
       * dentro, duraba exactamente lo que tardaba esa recarga: la persona pulsaba, no se guardaba
       * nada y la pantalla no decía nada.
       */
      errorAsignacion: null,
      dto: null,
      modo: 'SIN_GESTOR',
      gestorFiltrado: null,
      gestorElegido: null,
      /**
       * Lo escrito en el buscador de gestor (#479), y `null` cuando no se ha escrito nada.
       *
       * Los dos estados son distintos y de ahí cuelga el control entero: `null` es «el cuadro está
       * enseñando al gestor elegido», y una cadena —incluida la vacía— es «se está buscando». Con un
       * `''` para las dos cosas, abrir la lista borraría de la pantalla al gestor ya elegido.
       */
      terminoGestor: null,
      listaGestoresAbierta: false,
      /** Qué opción está resaltada, para poder elegir con el teclado. -1 es ninguna. */
      indiceResaltado: -1,
      /**
       * Las facturas marcadas, por id. Un objeto y no una lista porque la tabla pregunta por cada
       * fila en cada repintado: con una lista, 695 filas son 695 búsquedas lineales por pintada.
       * Se toca con `$set`/`$delete`, que es lo que Vue 2 necesita para enterarse de una clave
       * nueva.
       */
      seleccion: {},
      /** El resultado de la última asignación, que se queda en pantalla hasta que se oculta. */
      resultado: null
    };
  },
  computed: {
    /** Si la pantalla está enseñando datos ahora mismo. Gobierna el sello de datos (#16). */
    hayDatos: function() {
      return !!this.dto && !this.cargando;
    },
    filas: function() {
      return (this.dto && this.dto.facturas) || [];
    },
    /**
     * #749 · El modo de las filas que hay en la tabla, que lo dice la respuesta, y no el del botón
     * pulsado. Hasta la #749 eran lo mismo porque la tabla desaparecía mientras cargaba; ahora se
     * queda a la vista, y con `modo` la columna «Gestor actual» saldría vacía sobre las filas sin
     * gestor del modo anterior.
     */
    modoDeLasFilas: function() {
      return (this.dto && this.dto.modo) || this.modo;
    },
    gestoresDisponibles: function() {
      return (this.dto && this.dto.gestoresDisponibles) || [];
    },
    gestoresConCartera: function() {
      return (this.dto && this.dto.gestoresConCartera) || [];
    },
    /**
     * Las opciones del filtro «Gestor actual», **más el gestor que está filtrado si ya no está en
     * la lista**.
     *
     * Es el mismo desajuste que el del selector de asignar, en el otro selector de la pantalla, y
     * aquí es el caso de uso principal: se filtra por alguien, se le reparte TODA su cartera a otro
     * —que es para lo que existe el modo «ya asignadas»— y entonces deja de tener facturas abiertas
     * asignadas, así que desaparece de `gestoresConCartera`. Sin esta opción, el `<select>` no
     * encontraba ninguna que casara y se quedaba en blanco, como si el filtro fuera «Todos», con la
     * tabla recortada por un gestor que no se veía en ninguna parte.
     *
     * Y aquí se **enseña** el filtro en vez de limpiarlo, al contrario que en el de asignar: con el
     * filtro puesto la tabla sale vacía y la pantalla dice «ese gestor no tiene ninguna factura
     * abierta asignada», que es exactamente la noticia. Limpiarlo cambiaría la lista que la persona
     * está mirando sin que lo haya pedido. En el de asignar sí se limpia, porque de ahí sale una
     * escritura.
     */
    opcionesFiltroGestor: function() {
      const opciones = this.gestoresConCartera;
      const filtrado = this.gestorFiltrado;
      if (!filtrado) return opciones;
      const esta = opciones.some(function(opcion) { return opcion.clave === filtrado; });
      return esta
        ? opciones
        : opciones.concat([{ clave: filtrado, etiqueta: filtrado, documentos: 0 }]);
    },
    hayGestores: function() {
      return this.gestoresDisponibles.length > 0;
    },
    /**
     * Los gestores que casan con lo escrito, por **nombre o por código** (#479).
     *
     * Sin nada escrito, la lista entera: se sigue pudiendo abrir y elegir sin escribir, igual que
     * con el `<select>` de antes. Y los dos campos por separado en vez de pegados en una cadena,
     * para que un término no case a caballo entre el final del nombre y el principio del código.
     */
    gestoresFiltrados: function() {
      const termino = this.normalizarBusqueda(this.terminoGestor);
      if (!termino) return this.gestoresDisponibles;
      const self = this;
      return this.gestoresDisponibles.filter(function(gestor) {
        return self.normalizarBusqueda(gestor.nombre).indexOf(termino) !== -1
          || self.normalizarBusqueda(gestor.username).indexOf(termino) !== -1;
      });
    },
    /**
     * El nombre del gestor elegido **tal como lo ofrece la lista de esta carga**, o la cadena vacía.
     *
     * Derivado y no guardado: es lo que hace que el cuadro no pueda quedarse enseñando a alguien que
     * ya no está entre los empleados activos. `olvidarGestorQueYaNoEsta()` limpia la elección en
     * cuanto llega la respuesta, pero aunque no llegara a correr, aquí no hay a quién enseñar y el
     * cuadro vuelve solo a «Elige un gestor…», que es lo que de verdad está pasando.
     */
    etiquetaGestorElegido: function() {
      const self = this;
      const elegido = this.gestoresDisponibles.filter(function(gestor) {
        return self.esElGestorElegido(gestor);
      })[0];
      return elegido ? this.etiquetaGestor(elegido) : '';
    },
    /** Lo que se lee en el cuadro: lo que se está buscando o, si no se busca nada, a quién se eligió. */
    textoBuscadorGestor: function() {
      return this.terminoGestor === null ? this.etiquetaGestorElegido : this.terminoGestor;
    },
    /** La opción resaltada, para que un lector de pantalla lea la que se va a elegir con Enter. */
    idOpcionResaltada: function() {
      return this.listaGestoresAbierta && this.indiceResaltado >= 0
        ? 'gestor-opcion-' + this.indiceResaltado
        : null;
    },
    omitidas: function() {
      return (this.resultado && this.resultado.omitidas) || [];
    },
    /** Los ids marcados. Es lo que viaja al asignar. */
    marcadas: function() {
      const seleccion = this.seleccion;
      return Object.keys(seleccion).filter(function(id) { return !!seleccion[id]; });
    },
    /**
     * Si el gestor elegido **sigue estando en el desplegable de esta carga**.
     *
     * No es lo mismo que «hay un gestor elegido»: la elección es estado de la pantalla y sobrevive a
     * las recargas, y la lista de empleados activos la trae cada respuesta. Si entre medias se
     * desactiva a ese empleado, el control se queda sin nadie a quien enseñar —en blanco— y
     * `gestorElegido` seguiría apuntando a él: se marcaban facturas nuevas, el botón volvía a
     * encenderse y se asignaba un username que la pantalla ya no ofrece. Hallazgo P2 de la revisión
     * CODEX del PR #1751.
     *
     * Se compara con la misma tolerancia que el servidor —ni mayúsculas ni espacios—, para que un
     * username escrito torcido en la ficha del empleado no apague el botón por un espacio.
     */
    gestorElegidoVigente: function() {
      const clave = this.claveUsuario(this.gestorElegido);
      if (!clave) return false;
      const self = this;
      return this.gestoresDisponibles.some(function(gestor) {
        return self.claveUsuario(gestor.username) === clave;
      });
    },
    /**
     * Si el botón de asignar está vivo: hay marcadas, el gestor elegido sigue en la lista vigente y
     * no hay otra asignación en vuelo.
     *
     * Lo de «en vuelo» no es cosmético: dos pulsaciones seguidas serían dos escrituras de las mismas
     * facturas. La segunda no haría daño —el servidor ve que ya tienen ese gestor y no vuelve a
     * escribir, así que el histórico no gana entradas de más—, pero el resultado que quedaría en
     * pantalla sería el de la segunda, que dice «ya lo tenían» de todo lo que la primera acababa de
     * asignar.
     *
     * #749 · Y tampoco mientras se recarga: las marcas se tiran al empezar y la tabla no se puede
     * marcar hasta que llega la lista nueva, así que esto solo cierra la puerta por si acaso.
     */
    sePuedeAsignar: function() {
      return !this.asignando && !this.refrescando && this.hayGestores && this.gestorElegidoVigente
        && this.marcadas.length > 0;
    },
    /**
     * Qué se dice cuando la tabla sale vacía, que no es lo mismo en los dos modos. Con el modo y el
     * gestor de las filas que hay en pantalla (#749), no con lo que se acaba de pedir.
     */
    textoTablaVacia: function() {
      if (this.modoDeLasFilas === 'ASIGNADAS') {
        return this.gestorDeLasFilas
          ? 'Ese gestor no tiene ninguna factura abierta asignada.'
          : 'Todavía no hay ninguna factura con gestor de cobro asignado.';
      }
      return 'No hay ninguna factura sin gestor de cobro: toda la cartera que ves tiene dueño.';
    }
  },
  /**
   * El carril de peticiones se crea aquí y no en `data`: no es estado de pantalla y meterlo en
   * `data` lo volvería reactivo para nada.
   *
   * Uno solo, y solo para la **lectura**. La asignación NO va por carril a propósito: un carril
   * descarta la respuesta de una petición que ha dejado de ser la última, y la respuesta de una
   * escritura no se puede descartar nunca —es la única noticia que hay de lo que se ha escrito—.
   * Lo que impide lanzar dos es `asignando`.
   */
  created: function() {
    const self = this;
    // #472 · El «cargando» lo enciende y lo apaga el carril, que es el único que sabe cuándo ha
    // contestado la petición vigente: una respuesta descartada no lo apaga, y no hay un `false` por
    // manejador que olvidar.
    //
    // #749 · Pero aquí hay DOS indicadores, y el carril solo avisa de uno: el aviso se reparte. Con
    // la bandeja delante, una recarga la deja como está y avisa en `refrescando`; solo sin nada que
    // conservar —la primera carga, o después de un fallo— se enciende `cargando`, que es el que
    // despinta la bandeja. Encender `cargando` siempre devolvería la pantalla en blanco y la vuelta
    // al principio con cada cambio de modo o de gestor, que es el fallo que arregla la #749.
    this.carrilBandeja = carrilPeticiones({
      cargando: function(si) {
        if (!si) {
          self.cargando = false;
          self.refrescando = false;
        } else if (self.dto) {
          self.refrescando = true;
        } else {
          self.cargando = true;
        }
      }
    });
  },
  methods: {
    onPageInit: function() {
      this.cargar();
    },
    /** Pide la bandeja con el modo y el filtro puestos. */
    cargar: function() {
      const self = this;
      const filtro = self.filtroParaLaApi();
      self.error = null;
      // Las marcas se van con la lista: la que llegue puede no traer las mismas filas. Y mientras
      // llega, la tabla no se deja marcar (ver `marcar`).
      self.quitarMarcas();
      // Y el buscador de gestor se cierra: sus opciones son las de la carga anterior, y la que llegue
      // puede quitar justo la resaltada. Hasta la #749 lo cerraba de paso el despintado de la
      // bandeja; ahora la bandeja se queda, así que el cierre es lo único que lo garantiza.
      self.cerrarListaGestores();
      self.carrilBandeja.lanzar(FactCobro.bandeja(filtro), {
        exito: function(respuesta) {
          self.dto = respuesta;
          self.gestorDeLasFilas = filtro.gestores ? filtro.gestores[0] : null;
          // Otra vez, por lo mismo que al empezar: ninguna marca puede sobrevivir al cambio de lista.
          self.quitarMarcas();
          // El modo que manda es el que diga el servidor, no el que se pidió: así no se puede estar
          // viendo un modo y creer que es el otro.
          if (respuesta && respuesta.modo) self.modo = respuesta.modo;
          // Y la elección del desplegable se contrasta con la lista que acaba de llegar: lo demás
          // de esta pantalla viene del `dto` y se renueva solo, pero esa es estado propio y
          // sobrevive a las recargas.
          self.olvidarGestorQueYaNoEsta();
        },
        limpiar: function() {
          self.gestorDeLasFilas = null;
          // Sin datos no se deja lo de antes en pantalla: el sello de datos y los recuentos estarían
          // afirmando algo sobre una bandeja que esta pantalla ya no está enseñando. Y las casillas
          // de una tabla que no está serían marcas sobre facturas invisibles.
          self.dto = null;
        },
        fallo: function(e) {
          self.error = e && e.status === 403
            ? 'No tienes acceso a la bandeja de asignación.'
            : 'No se ha podido cargar la bandeja. Vuelve a intentarlo con el botón de recargar.';
        }
      });
    },
    filtroParaLaApi: function() {
      return {
        modo: this.modo,
        // El filtro por gestor es solo del modo «ya asignadas»: en el otro no hay gestor por el que
        // filtrar, y mandarlo recortaría una lista en la que ese campo está vacío en todas.
        gestores: this.modo === 'ASIGNADAS' && this.gestorFiltrado ? [this.gestorFiltrado] : null
      };
    },
    cambiarModo: function(modo) {
      if (this.modo === modo) return;
      this.modo = modo;
      // El filtro por gestor es del otro modo: dejarlo puesto recortaría sin que se vea el selector.
      this.gestorFiltrado = null;
      this.cargar();
    },
    aplicarFiltro: function() {
      this.cargar();
    },
    marcar: function(fila, marcada) {
      // #749 · Mientras se recarga, las filas de la tabla son las de la lista anterior: marcar una
      // sería apuntar a una factura que la lista nueva puede no traer. Las casillas ya salen
      // apagadas; esto cubre lo que llegue por otro camino.
      if (this.refrescando) return;
      if (marcada) {
        if (this.marcadas.length >= this.dto.topeAsignacion) return;
        this.$set(this.seleccion, fila.id, true);
      } else {
        this.$delete(this.seleccion, fila.id);
      }
    },
    /**
     * Marca las filas que se están viendo, hasta el tope del servidor.
     *
     * Hasta el tope y no todas: si se marcaran 695 y el servidor acepta 500, la asignación se
     * rechazaría entera después de haberlas marcado. Y «las visibles» y no «todas» porque lo que no
     * está en la tabla no se ha pintado y nadie lo ha visto.
     */
    marcarTodas: function() {
      if (this.refrescando) return;
      const seleccion = {};
      const tope = this.dto.topeAsignacion;
      this.filas.forEach(function(fila) {
        if (Object.keys(seleccion).length < tope) seleccion[fila.id] = true;
      });
      this.seleccion = seleccion;
    },
    quitarMarcas: function() {
      this.seleccion = {};
    },
    /**
     * Si el gestor elegido ya no está entre los empleados activos de esta carga, se olvida.
     *
     * El buscador no tiene a nadie a quien enseñar, así que se ve en blanco: dejar el valor puesto es
     * tener la pantalla diciendo una cosa y el estado otra. Volver a «Elige un gestor…» es lo que de
     * verdad está pasando. `sePuedeAsignar` lo comprueba también, y eso es lo que impide la escritura
     * si esta limpieza no llegara a correr; y desde la #479 el texto del cuadro se deriva de la lista
     * vigente (`etiquetaGestorElegido`), así que tampoco puede quedarse un nombre pintado.
     */
    olvidarGestorQueYaNoEsta: function() {
      if (this.gestorElegido && !this.gestorElegidoVigente) this.gestorElegido = null;
    },
    // ---------------------------------------------------------------- EL BUSCADOR DE GESTOR (#479)

    /**
     * Cómo se compara un texto al buscar: sin mayúsculas, sin acentos y sin los espacios de los
     * lados. Misma forma que el resto de buscadores de la aplicación (`mapa-aprobacion.vue`,
     * `restricciones.vue`).
     *
     * El `NFD` parte cada letra acentuada en letra + tilde y el reemplazo se queda solo con la
     * letra, así que «munoz» encuentra a Muñoz y «cruz» a de la Cruz. Sin esto, buscar sin acentos
     * —que es como se escribe cuando se va rápido— no encontraría a media plantilla.
     */
    normalizarBusqueda: function(valor) {
      if (valor === null || valor === undefined) return '';
      return String(valor).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
    },
    /** Lo que se lee de cada entrada de la lista. El mismo texto que ponía el `<option>`. */
    etiquetaGestor: function(gestor) {
      if (!gestor) return '';
      return (gestor.nombre || gestor.username || '') + ' (' + (gestor.username || '') + ')';
    },
    /** Si esa entrada es la elegida, con la misma tolerancia que el servidor (ver `claveUsuario`). */
    esElGestorElegido: function(gestor) {
      const clave = this.claveUsuario(this.gestorElegido);
      return !!clave && !!gestor && this.claveUsuario(gestor.username) === clave;
    },
    /**
     * Abre la lista, y mientras no se haya escrito nada **selecciona el texto del cuadro**.
     *
     * Lo segundo no es un detalle: en el cuadro se lee «Ana García (AGA)», que no es ni un nombre ni
     * un código, así que si la primera tecla se añadiera a ese texto en vez de sustituirlo, la
     * búsqueda saldría vacía nada más empezar a escribir.
     */
    abrirListaGestores: function() {
      if (!this.hayGestores) return;
      this.sincronizarCampoGestor();
      if (this.listaGestoresAbierta) return;
      this.listaGestoresAbierta = true;
      this.indiceResaltado = this.indiceDelGestorElegido();
      this.asomarOpcionResaltada();
    },
    /**
     * Deja el cuadro diciendo lo que dice el estado y, cuando eso es la etiqueta del gestor elegido,
     * la deja **seleccionada** para que la primera tecla la sustituya.
     *
     * Por el `ref` y no por el `target` del evento, que es lo que hacía antes `abrirListaGestores`:
     * los caminos que de verdad se quedaban sin seleccionar son los que **no traen ningún evento del
     * campo** porque el foco ya estaba dentro —elegir con Enter o con el ratón (`mousedown.prevent`
     * impide incluso que lo pierda), cerrar con Esc, abrir con las flechas—. Con el `target` del
     * evento no había forma de alcanzarlos.
     *
     * Y en `$nextTick` porque la etiqueta la pinta Vue DESPUÉS de que cambie este estado: seleccionar
     * antes del repintado selecciona el texto viejo.
     *
     * El `value` se escribe solo si no cuadra, que es el caso del recorte de `buscarGestor()`: ahí
     * en el DOM ha quedado la etiqueta con la tecla pegada detrás y el estado ya es solo la tecla, y
     * el cuadro no puede estar diciendo una cosa mientras la lista filtra por otra (CLAUDE.md §9).
     * Escribirlo cuando ya cuadra movería el cursor al final a cada tecla.
     */
    sincronizarCampoGestor: function() {
      const self = this;
      if (typeof self.$nextTick !== 'function') return;
      self.$nextTick(function() {
        const campo = self.$refs && self.$refs.campoGestor;
        if (!campo) return;
        const texto = self.textoBuscadorGestor;
        if (typeof campo.value === 'string' && campo.value !== texto) campo.value = texto;
        if (self.terminoGestor === null && campo.select) campo.select();
      });
    },
    /**
     * Cierra la lista y tira lo escrito, para que el cuadro vuelva a enseñar al gestor elegido —o el
     * hueco, si al escribir se dejó de haber ninguno—. Un término de búsqueda que se quedara ahí
     * sería texto en el cuadro que no es a quien se va a asignar.
     */
    cerrarListaGestores: function() {
      this.listaGestoresAbierta = false;
      this.indiceResaltado = -1;
      this.terminoGestor = null;
    },
    /**
     * Teclear es **buscar**, así que deja de haber gestor elegido hasta que se elija uno de la lista.
     *
     * Guardar la elección mientras se escribe encima dejaría el cuadro diciendo una cosa y la
     * asignación yéndose a otra. Al quedarse sin elección sale solo el aviso que ya existe —«Elige
     * un gestor en el desplegable para poder asignar.»— y el botón se apaga, que es lo cierto.
     */
    buscarGestor: function(texto) {
      const escrito = texto === null || texto === undefined ? '' : String(texto);
      // Si el cuadro venía enseñando la etiqueta del gestor elegido, lo tecleado es lo que NO forma
      // parte de ella. `sincronizarCampoGestor()` deja esa etiqueta seleccionada para que la tecla
      // la sustituya, pero la selección es cosa del navegador y puede no prender —un teclado de
      // móvil, un repintado por medio—: sin este recorte se buscaría por «Ana García (AGA)m», que no
      // casa con nadie, y la lista saldría vacía justo cuando se quiere cambiar de gestor.
      this.terminoGestor = this.terminoGestor === null
        ? this.loTecleadoSobreLaEtiqueta(escrito)
        : escrito;
      this.listaGestoresAbierta = this.hayGestores;
      this.indiceResaltado = -1;
      this.gestorElegido = null;
      this.sincronizarCampoGestor();
    },
    /**
     * Lo que se acaba de teclear **encima** de la etiqueta del gestor elegido.
     *
     * Del campo llega su valor entero, no la tecla, así que hay que decidir cuál de las dos cosas
     * ha pasado. Si la selección prendió, ese valor **es** lo escrito y no hay nada que descontar.
     * Si no prendió, la etiqueta sigue dentro del valor y lo nuevo viene con ella alrededor. Y las
     * dos tienen una forma reconocible, porque un solo evento del campo es una sola edición:
     *
     * - **metió algo**: el valor es MÁS LARGO que la etiqueta, y lo que no es nuevo —el trozo
     *   común del principio más el del final— la cubre entera. Lo de en medio es lo tecleado, y
     *   vale igual si la tecla cayó al final (donde queda el cursor al pintar la etiqueta), al
     *   principio o donde estuviera;
     * - **borró**: una tecla de borrar sin selección quita UN carácter, así que el valor es la
     *   etiqueta menos uno. No se ha escrito nada nuevo y el término sale vacío, o sea la lista
     *   entera: borrar la etiqueta es dejar de tener algo que buscar, no buscar un trozo de ella.
     *
     * Cualquier otro valor es que la etiqueta **ya no está en el cuadro**, o sea que la selección
     * prendió, y entonces se busca por el valor entero. Esto es lo que arregla el hallazgo P2 de la
     * ronda 2 del PR #1787: una búsqueda que empieza igual que la etiqueta —escribir una «A» sobre
     * «Andrea de la Cruz Ortega (ACO)», o pegar «Andrea»— se descontaba como si fuera prefijo
     * conservado y el término salía VACÍO, con el cuadro diciendo «A» y la lista ofreciendo a la
     * plantilla entera (CLAUDE.md §9: no pueden decir lo contrario la una de la otra).
     *
     * Las dos lecturas no se pueden tener a la vez y hay que elegir: «A» es, letra por letra, lo
     * mismo que quedaría al borrar la etiqueta de la segunda letra en adelante. Manda la búsqueda,
     * que es el camino normal del control —al elegir, la etiqueta queda seleccionada a propósito—,
     * y lo que se pierde es un borrado de varios caracteres cuando esa selección NO prendió: ahí el
     * cuadro se queda diciendo el resto de la etiqueta y la lista no casa con nadie, que es verdad
     * y es coherente con lo que se lee, y sigue recortando a cada tecla de borrar.
     *
     * Sin gestor elegido no hay etiqueta ninguna y lo escrito pasa tal cual: esto solo descuenta lo
     * que el propio control había puesto en el cuadro.
     */
    loTecleadoSobreLaEtiqueta: function(escrito) {
      const etiqueta = this.etiquetaGestorElegido;
      if (!etiqueta) return escrito;
      let ini = 0;
      while (ini < escrito.length && ini < etiqueta.length
        && escrito.charAt(ini) === etiqueta.charAt(ini)) ini++;
      let fin = 0;
      while (fin < escrito.length - ini && fin < etiqueta.length - ini
        && escrito.charAt(escrito.length - 1 - fin)
          === etiqueta.charAt(etiqueta.length - 1 - fin)) fin++;
      if (escrito.length > etiqueta.length && ini + fin >= etiqueta.length) {
        return escrito.slice(ini, escrito.length - fin);
      }
      if (escrito.length === etiqueta.length - 1 && ini + fin >= escrito.length) return '';
      return escrito;
    },
    elegirGestor: function(gestor) {
      if (!gestor) return;
      this.gestorElegido = gestor.username;
      this.cerrarListaGestores();
      // El cuadro pasa a decir «Nombre (CÓDIGO)» con el foco todavía dentro, así que quien quiera
      // cambiar de gestor va a escribir ahí mismo sin volver a pulsar: la etiqueta se queda
      // seleccionada para que la tecla la sustituya. Hallazgo P2 de la revisión CODEX del PR #1787.
      this.sincronizarCampoGestor();
    },
    /**
     * Esc deja la búsqueda y devuelve el cuadro al gestor elegido. Mismo caso que elegir —el foco
     * sigue dentro y lo que se lee vuelve a ser la etiqueta—, así que se selecciona por lo mismo.
     */
    cancelarBusquedaGestor: function() {
      this.cerrarListaGestores();
      this.sincronizarCampoGestor();
    },
    /**
     * Enter elige. Con una opción resaltada, esa; sin ninguna, la primera de las que casan, que es lo
     * que hace el autocompletado del resto de la aplicación (`rAutocomplete.onPressEnter`).
     */
    elegirResaltado: function() {
      if (!this.listaGestoresAbierta) { this.abrirListaGestores(); return; }
      const lista = this.gestoresFiltrados;
      if (!lista.length) return;
      const resaltada = this.indiceResaltado >= 0 && this.indiceResaltado < lista.length
        ? lista[this.indiceResaltado]
        : lista[0];
      this.elegirGestor(resaltada);
    },
    /** Sube o baja por la lista, dando la vuelta por los extremos. Con la lista cerrada, la abre. */
    moverResaltado: function(paso) {
      if (!this.hayGestores) return;
      if (!this.listaGestoresAbierta) { this.abrirListaGestores(); return; }
      const total = this.gestoresFiltrados.length;
      if (!total) { this.indiceResaltado = -1; return; }
      const siguiente = this.indiceResaltado + paso;
      this.indiceResaltado = siguiente < 0 ? total - 1 : (siguiente >= total ? 0 : siguiente);
      this.asomarOpcionResaltada();
    },
    /** Dónde está el gestor elegido en la lista que se está enseñando, o -1 si no está. */
    indiceDelGestorElegido: function() {
      const lista = this.gestoresFiltrados;
      for (let i = 0; i < lista.length; i++) {
        if (this.esElGestorElegido(lista[i])) return i;
      }
      return -1;
    },
    /**
     * Deja a la vista la opción resaltada: la lista tiene tope de alto y con cuarenta empleados el
     * resaltado se iría por debajo del borde al bajar con el teclado.
     *
     * Se calla si no hay DOM —el banco de pruebas monta la pantalla en Node— en vez de condicionar
     * nada de lo de arriba: esto es solo que se vea.
     */
    asomarOpcionResaltada: function() {
      const self = this;
      if (!self.$nextTick) return;
      self.$nextTick(function() {
        const lista = self.$refs && self.$refs.listaGestores;
        const opciones = (self.$refs && self.$refs.opcionesGestor) || [];
        const opcion = opciones[self.indiceResaltado];
        if (!lista || !opcion || typeof lista.scrollTop !== 'number') return;
        const alto = lista.clientHeight;
        if (opcion.offsetTop < lista.scrollTop) {
          lista.scrollTop = opcion.offsetTop;
        } else if (opcion.offsetTop + opcion.offsetHeight > lista.scrollTop + alto) {
          lista.scrollTop = opcion.offsetTop + opcion.offsetHeight - alto;
        }
      });
    },
    /**
     * La clave con la que se compara un username, igual que en el servidor: sin distinguir
     * mayúsculas ni los espacios alrededor. Un hueco no es ninguna clave.
     */
    claveUsuario: function(valor) {
      if (valor === null || valor === undefined) return null;
      const limpio = String(valor).trim().toUpperCase();
      return limpio === '' ? null : limpio;
    },
    /** Si ese rechazo pide que alguien lo mire. Lo decide el servidor, no una lista de aquí. */
    avisa: function(omitida) {
      return !!(omitida && omitida.exigeComprobar);
    },
    /**
     * Asigna el gestor a las facturas marcadas y vuelve a cargar la bandeja.
     *
     * Se recarga **siempre**, también si la respuesta dice que no se ha asignado nada: lo que ha
     * quedado escrito lo sabe la base de datos, no esta pantalla, y seguir enseñando la lista de
     * antes dejaría marcadas facturas que ya tienen dueño.
     */
    asignar: function() {
      const self = this;
      if (!self.sePuedeAsignar) return;
      const ids = self.marcadas;
      const gestor = self.gestorElegido;
      // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que lo soltaba.
      cerrojoDeLaSesion(self, 'asignando');
      self.errorAsignacion = null;
      FactCobro.asignarGestor(ids, gestor).then(function(respuesta) {
        self.asignando = false;
        self.resultado = respuesta;
        self.cargar();
      }, function(e) {
        self.asignando = false;
        self.resultado = null;
        if (e && e.status === 403) {
          self.errorAsignacion = 'Asignar el gestor de cobro es de Administración, Dirección y '
            + 'Administrador. No se ha asignado nada.';
        } else {
          // Un fallo de red o una pasarela que corta no dice si se ha escrito o no, así que no se
          // afirma ninguna de las dos cosas: se recarga y se dice que hay que mirar.
          self.errorAsignacion = 'No se sabe si la asignación se ha llegado a guardar. Se ha vuelto '
            + 'a cargar la bandeja: comprueba cómo han quedado esas facturas antes de volver a '
            + 'asignarlas.';
        }
        self.cargar();
      });
    },
    /**
     * Una fecha del servidor (`2026-10-02`) como se escribe aquí: `02/10/2026`. Sin `new Date()`,
     * que interpreta la cadena en UTC y en Valladolid puede devolver el día de antes.
     */
    formatFecha: function(valor) {
      if (!valor) return '—';
      const partes = String(valor).substring(0, 10).split('-');
      if (partes.length !== 3) return String(valor);
      return partes[2] + '/' + partes[1] + '/' + partes[0];
    },
    /** Euros enteros, que es como se leen estas cifras. Un hueco es un guion, nunca un cero. */
    formatEuros: function(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      return Math.round(Number(valor)).toLocaleString('es-ES');
    },
    /**
     * Un número de columna, con el hueco como guion.
     *
     * D-COB-8 en una línea: una factura sin fecha de vencimiento no tiene «0 días de retraso», tiene
     * «no se sabe», y un cero ahí se lee como que está al día.
     */
    numero: function(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      return Number(valor).toLocaleString('es-ES');
    },
    /** Un texto de columna, con el hueco como guion. Mismo motivo que `numero`. */
    texto: function(valor) {
      return valor === null || valor === undefined || valor === '' ? '—' : String(valor);
    },
    /**
     * El estado de gestión de cobro **escrito en castellano**.
     *
     * La API manda el código del `EstadoGestionCobroEnum` tal cual —es el contrato, y así lo
     * reciben también la ficha de factura y la pantalla de la cartera—, y los nombres para leer
     * viven en el front, en `facturas.estadoGestionCobroValores`. Se reutilizan esos: con una tabla
     * propia aquí, la bandeja y la ficha acabarían llamando distinto al mismo estado.
     *
     * Un código que no esté en la tabla se enseña **tal cual** y no como «—» ni como la ruta de la
     * clave de idiomas: un valor que no sabemos traducir sigue siendo un dato, y esconderlo es
     * justo lo que D-COB-8 no quiere. El hueco de verdad —el campo vacío— sí es un guion, y lo que
     * significa está en el pie de la tabla.
     */
    etiquetaEstadoGestion: function(codigo) {
      if (codigo === null || codigo === undefined || codigo === '') return '—';
      const clave = 'facturas.estadoGestionCobroValores.' + codigo;
      const etiqueta = this.$t(clave);
      // vue-i18n devuelve la clave entera cuando no hay traducción.
      return !etiqueta || etiqueta === clave ? String(codigo) : etiqueta;
    },
    /**
     * Abre la ficha de la factura **en una pestaña nueva**, en modo solo lectura.
     *
     * Pestaña nueva y no `$f7router.navigate`: lo marcado en la tabla es estado de esta pantalla
     * (ver `seleccion`) y salir de ella lo tira. Quien está repartiendo una tanda de facturas tiene
     * que poder mirar una sin perder las otras veinte que llevaba marcadas.
     *
     * Con `window.open` y no con un `<a target="_blank">` porque el router de Framework7 intercepta
     * los href internos y se quedaría en la misma pestaña; mismo motivo y misma forma que en la
     * ficha de items enriquecidos. La URL va **relativa al fragmento**, que es lo que funciona
     * también si la aplicación se sirve bajo un subcamino.
     *
     * Y la ficha en `view` y no en `edit`: desde aquí se va a mirar la factura que se está
     * decidiendo, no a cambiarla. Esta pantalla escribe una cosa y solo una (criterio 7).
     */
    abrirFicha: function(fila) {
      if (!fila || !fila.id) return;
      window.open('#!/facturas/view/' + encodeURIComponent(fila.id) + '/', '_blank', 'noopener');
    }
  }
};
</script>
